export const environment = {
  production: true,
  connection: {
    name: 'LH Horitschon Softline',
    host: 'https://softline.horitschon.rlh.at/',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
